import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-show-avatar',
  templateUrl: './show-avatar.component.html',
  styleUrls: ['./show-avatar.component.scss']
})
export class ShowAvatarComponent {

  @Input() link;
  @Input() size;
  @Input() role;
  @Input() bandType;
  @Input() background = false;
  @Input() border = false;

  get avatar() {
    return `${environment.avatar_url}${this.link}`;
  }

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/show-avatar/show-avatar.component.ts